import { Outlet } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { ImagePreviewProvider } from "@/components/feature/ImagePreviewProvider";

export default function Layout() {
  return (
    <ImagePreviewProvider>
      <div className="flex min-h-screen flex-col bg-background-50">
        <Navbar />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </ImagePreviewProvider>
  );
}